/* ==========================================================================
   ReLEAF — LEAFs product page variant sync
   Same pattern as the Ready-to-Wear page: price, availability and the hidden
   variant id are driven from the real variant list Liquid prints into the
   page, not inferred from the DOM. Bound to shopify:section:load so it
   survives the Theme Editor's section re-render.
   ========================================================================== */
window.ReLEAFLeafs = (function () {
  "use strict";

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var amount = parts.join(".");
    if (format && format.indexOf("{{") !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
    return "$" + amount;
  }

  function initProduct(root) {
    var scope = root || document;
    var form = scope.querySelector("[data-rl-lf-form]");
    if (!form) return;

    var dataEl = scope.querySelector("[data-rl-lf-variants]");
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return; // malformed JSON: leave the form exactly as Liquid rendered it
    }
    if (!variants || !variants.length) return;

    var selects = Array.prototype.slice.call(scope.querySelectorAll("[data-rl-lf-option]"));
    var idField = form.querySelector('input[name="id"]');
    var button = scope.querySelector("[data-rl-lf-add]");
    var label = scope.querySelector("[data-rl-lf-add-label]");
    var priceEl = scope.querySelector("[data-rl-lf-price]");
    var moneyFormat = document.body.getAttribute("data-money-format") || "";

    var STR = {
      add: dataEl.getAttribute("data-add") || "Add to cart",
      soldOut: dataEl.getAttribute("data-sold-out") || "Sold out",
      unavailable: dataEl.getAttribute("data-unavailable") || "Unavailable"
    };

    function chosen() {
      return selects.map(function (s) { return s.value; });
    }

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options || [];
        if (values.length !== opts.length) continue;
        var same = true;
        for (var j = 0; j < values.length; j++) {
          if (opts[j] !== values[j]) { same = false; break; }
        }
        if (same) return variants[i];
      }
      return null;
    }

    function update() {
      var variant = match(chosen());
      if (!variant) {
        if (idField) idField.value = "";
        if (button) button.disabled = true;
        if (label) label.textContent = STR.unavailable;
        return;
      }

      if (idField) idField.value = variant.id;
      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? STR.add : STR.soldOut;

      if (priceEl && typeof variant.price === "number") {
        var was = typeof variant.compare_at_price === "number" ? variant.compare_at_price : 0;
        var now = variant.price;
        var html = "<strong>" + money(now, moneyFormat) + "</strong>";
        if (was > now) html += " <s>" + money(was, moneyFormat) + "</s>";
        priceEl.innerHTML = html;
      }

      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url.toString());
        } catch (e) { /* non-blocking */ }
      }
    }

    selects.forEach(function (s) {
      if (s.dataset.rlBound) return;
      s.dataset.rlBound = "1";
      s.addEventListener("change", update);
    });
    update();
  }

  function initAll() { initProduct(document); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) { initProduct(e.target); });

  return { initAll: initAll, initProduct: initProduct };
})();
